import { render, staticRenderFns } from "./LightboxDocumentCard.vue?vue&type=template&id=5fd1c9d2&scoped=true&"
import script from "./LightboxDocumentCard.vue?vue&type=script&lang=js&"
export * from "./LightboxDocumentCard.vue?vue&type=script&lang=js&"
import style0 from "./LightboxDocumentCard.vue?vue&type=style&index=0&id=5fd1c9d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd1c9d2",
  null
  
)

export default component.exports